import { Formik } from "formik";
import { Grid, Box, CircularProgress, Divider } from '@mui/material';
import React, { useCallback, useEffect, useRef, useState } from 'react'
import * as Yup from "yup";
import { Link } from 'react-router-dom';
import './loginModalStyle.css';
import { ForgetPasswordText, ForgetPasswordWrapper } from './styles';
import { useStyles } from '../../assets/styles/LoginStyles';
import strings from '../../constant/strings';
import LogoIcon from '../Common/LogoIcon';
import RadioButtonBox1 from './RadioButtonBox1';
import { userList } from '../../constant/staticLists';
import { forgotPasswordSchema, loginSchema } from '../../utils/forms/schema.loginSchema';
import { StyledButton, StyledCrossIcon, StyledFormik, StyledImageCont, StyledLogo, StyledMainModalCont, StyledMargin, StyledPadding, StyledText } from '../../assets/styles/CommonStyles';
import { useDispatch, useSelector } from "react-redux";
import { SubadminLoginAction, doctorLoginAction, loginAction, organizationLoginAction, resendOtpAction, verifyOtpAction } from "../../redux/auth/authActions";
import FieldWrapper from "../InputField/TextFieldWrapper";
import * as authService from "../../services/authService.js";
import { toast } from 'react-toastify';
import { useHistory } from "react-router-dom";
import { clearOtpState } from "../../redux/auth/authSlice.js";

/**
 * `forceUserType` skips the "Login as..." step and signs the visitor in as that
 * account type. It is set only when they were sent here part-way through
 * something only one kind of account can do - a pre-order. Left empty, which is
 * every other entry point, the chooser behaves exactly as before.
 */
const LoginModal1 = ({ isSignUpModal, setLoginToggle, loginToggle, toggleLogin, forceUserType = '' }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { error, isOtpSent } = useSelector(state => ({
    error: state.auth.error,
    isOtpSent: state.auth.isOtpSent // Add this to your auth state
  }))
  const history = useHistory();
  const [activeRadio, setActiveRadio] = useState(forceUserType);
  // Non-empty means the chooser is already answered, so the form shows at once.
  const [radioProced, setRadioProced] = useState(forceUserType);
  const [mobile, setMobile] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [isForgetPassword, setForgetPassword] = useState(false);
  const [isOtpStep, setIsOtpStep] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  const [resendLoading, setResendLoading] = useState(false);
  const [timer, setTimer] = useState(0);
  const [canResend, setCanResend] = useState(false);
  const handleSignupButton = useCallback(() => {
    toggleLogin();
    setMobile(false);
  }, [mobile]);

  // The API urls resolve the account type out of storage, so a forced type has
  // to be written there as well as held in state.
  useEffect(() => {
    if (!forceUserType) return;
    localStorage.setItem("userType", forceUserType);
    sessionStorage.setItem("userType", forceUserType);
  }, [forceUserType]);


  const renderLoginApi = async (values) => {
    /*
     * A forced type wins. The pre-order page opens this modal with
     * forceUserType="patient" and hides the role selector, so nothing
     * left over in state or storage from an earlier role should be able
     * to send the login - and every url after it - somewhere else.
     */
    const currentUserType = forceUserType || activeRadio || sessionStorage.getItem("userType") || "patient";
    localStorage.setItem("userType", currentUserType);
    sessionStorage.setItem("userType", currentUserType);
    setUserEmail(values.email);
    const passData = { email: values.email, password: values.password, loginType: 2 }
    dispatch(loginAction(passData));
    // if (currentUserType === "patient") {
    //   dispatch(loginAction(passData));
    // } 
    // else if(currentUserType === "doctor"){
    //   dispatch(doctorLoginAction(passData));
    // }
    // else if(currentUserType === "organization"){
    //   dispatch(organizationLoginAction(passData));
    // }
    // else if(currentUserType === "subadmin"){
    //   dispatch(SubadminLoginAction(passData));
    // }
    setTimeout(() => {
      setButtonLoading(false);
    }, 2000);
  }

  // Simplified OTP functions since we're using unified actions
  const handleOtpSubmit = async (values) => {
    setButtonLoading(true);
    const otpData = {
      email: userEmail,
      otp: values.otp,
      loginType: 2
    };

    dispatch(verifyOtpAction(otpData));

    setTimeout(() => {
      setButtonLoading(false);
    }, 2000);
  }

  // Unified resend OTP function
  const handleResendOtp = async () => {
    if (!canResend) return;
    setResendLoading(true);
    const resendData = {
      email: userEmail,
      loginType: 2
    };

    dispatch(resendOtpAction(resendData));
    setTimer(60); // 1 minute = 60 seconds
    setCanResend(false);
    setTimeout(() => {
      setResendLoading(false);
    }, 2000);
  }

  useEffect(() => {
    let interval = null;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer(timer => {
          if (timer <= 1) {
            setCanResend(true);
            return 0;
          }
          return timer - 1;
        });
      }, 1000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [timer]);

  useEffect(() => {
    //sessionStorage.removeItem("userType");
    // Resets to the forced type rather than to '', so a page that fixes the
    // account type keeps it. Unset (every existing caller) this is still a
    // reset to '' and the chooser appears exactly as before.
    setActiveRadio(forceUserType);
    setRadioProced(forceUserType);
    setIsOtpStep(false);
    setUserEmail('');
    // REMOVED: These lines were destroying session data on mount!
    // sessionStorage.removeItem("userType");
    // localStorage.removeItem("userType");
  }, [isSignUpModal, forceUserType])

  // isOtpSent is persisted with the auth slice, so a value left over from an
  // unfinished earlier login would open the OTP step before any sign-in (and
  // hide the email/password form). Clear it once when the modal mounts.
  const staleOtpChecked = useRef(false);

  // Listen for OTP sent status
  useEffect(() => {
    if (!staleOtpChecked.current) {
      staleOtpChecked.current = true;
      if (isOtpSent) {
        dispatch(clearOtpState());
        return;
      }
    }
    if (isOtpSent) {
      setIsOtpStep(true);
      setTimer(60);
      setCanResend(false);
    }
  }, [isOtpSent]);

  const handleSubmit = (values) => {
    setButtonLoading(true);
    renderLoginApi(values);
  }


  const getForgotPasswordType = (userType) => {
    const typeMapping = {
      'patient': 2,
      'doctor': 1,
      'organization': 3,
      'subadmin': 4
    };
    return typeMapping[userType] || 2;
  };

  const handleForgetPasswordSubmit = async (values) => {
    setButtonLoading(true);
    const forgotPasswordType = getForgotPasswordType(activeRadio);
    const res = await authService.forgotPasswordAPI({ email: values.email, forgotPasswordType });
    if (res.response_type === "fail") {
      setButtonLoading(false);
      toast.error(res?.response?.message, { position: "bottom-center", closeButton: false, autoClose: 1000, style: { width: 'auto', borderRadius: 8 } });
    } else {
      setButtonLoading(false);
      toast.success(res?.response?.message, { position: "bottom-center", closeButton: false, autoClose: 1000, style: { width: 'auto', borderRadius: 8 } });
    }
  }

  const handleProceed = () => {
    setRadioProced(activeRadio)
  };
  const handleBackButton = useCallback(() => {
    dispatch(clearOtpState());
    // sessionStorage.removeItem("userType");
    // When the type was forced there is no chooser to go back to, so stay on
    // the form rather than showing a step this visitor never saw.
    setRadioProced(forceUserType);
    setActiveRadio(forceUserType);
    setMobile(false);
    setForgetPassword(false);
    setIsOtpStep(false);
    setUserEmail('');
    setTimer(0);
    setCanResend(false);
    // sessionStorage.removeItem("userType");
    // localStorage.removeItem("userType");
  }, [dispatch, forceUserType]);

  const handleCrossButton = () => {
    dispatch(clearOtpState());
    // sessionStorage.removeItem("userType");
    document.body.style.overflowY = 'auto'
    setLoginToggle(loginToggle => !loginToggle);
    setActiveRadio('');
    setRadioProced('');
    setMobile(false);
    setForgetPassword(false);
    setIsOtpStep(false);
    setUserEmail('');
    setTimer(0);
    setCanResend(false);
    // sessionStorage.removeItem("userType");
    // localStorage.removeItem("userType");
  }

  const renderSubmitButton = () => {
    if (isOtpStep) return 'Verify OTP';
    return isForgetPassword ? 'Forget password' : 'Log In';
  };

  const handleActiveRadio = (value) => {
    localStorage.setItem("userType", value);
    sessionStorage.setItem("userType", value);
    setActiveRadio(value);
  }

  // OTP validation schema
  const otpSchema = Yup.object().shape({
    otp: Yup.string()
      .required('OTP is required')
      .length(6, 'OTP must be 6 digits')
  });

  useEffect(() => {
    return () => {
      dispatch(clearOtpState());
      setTimer(0);
      setCanResend(false);
      // sessionStorage.removeItem("userType");
      // localStorage.removeItem("userType");
    };
  }, [dispatch]);

  return (
    <StyledMainModalCont>
      <StyledImageCont>
        <StyledCrossIcon
          src={"/assets/img/x.png"}
          alt="User"
          onClick={handleCrossButton}
        />
      </StyledImageCont>
      <StyledPadding>
        <div className={classes.logoCont}>
          <img
            src={"/assets/img/image1.png"}
            alt="User"
            className={classes.logoStyle}
          /></div>
        {radioProced === '' ?
          <>
            <div className={classes.mainTextStyle}>
              {strings.loginAs}
            </div>
            <div className={classes.radioStyle}>
              <RadioButtonBox1
                list={userList}
                activeRadio={activeRadio}
                setActiveRadio={handleActiveRadio}
                handleProceed={handleProceed}
              />
            </div> </> :
          <div>
            {/* Show OTP form if OTP step is active */}
            {isOtpStep ? (
              <Formik
                initialValues={{
                  otp: ""
                }}
                validationSchema={otpSchema}
                onSubmit={handleOtpSubmit}
              >
                {({ errors, handleSubmit }) => (
                  <StyledFormik>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <div className={classes.otpInfoText}>
                          Please enter the 6-digit OTP sent to {userEmail}
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <div style={{ minHeight: '90px' }}> {/* This prevents layout shift */}
                          <FieldWrapper
                            name="otp"
                            label="Enter OTP"
                            type="text"
                            maxLength={6}
                            autoComplete="one-time-code"
                          />
                        </div>
                      </Grid>
                    </Grid>

                    <Box m={1} pt={1}>
                      <StyledButton
                        name="submit"
                        disabled={Object.keys(errors).length > 0 || buttonLoading}
                        onClick={handleSubmit}
                        variant="contained">
                        {error === null && buttonLoading ? (
                          <CircularProgress
                            style={{ color: "white" }}
                            size={20}
                            thickness={5}
                          />
                        ) : renderSubmitButton()}
                      </StyledButton>
                    </Box>

                    {/* Resend OTP button */}
                    <Box textAlign="center" mt={2}>
                      <StyledText className={classes.textStyle}>
                        Didn't receive OTP?{' '}
                        <span
                          className="sign-color"
                          onClick={handleResendOtp}
                          style={{
                            cursor: resendLoading ? 'not-allowed' : 'pointer',
                            opacity: resendLoading ? 0.6 : 1
                          }}
                        >
                          {resendLoading ? 'Sending...' :
                            timer > 0 ? `Resend OTP in ${timer}s` : 'Resend OTP'}
                        </span>
                      </StyledText>
                    </Box>
                  </StyledFormik>
                )}
              </Formik>
            ) : (
              // Original login form
              <Formik
                initialValues={{
                  email: "",
                  password: ""
                }}
                validationSchema={isForgetPassword ? forgotPasswordSchema : loginSchema}
                onSubmit={(values) => isForgetPassword ? handleForgetPasswordSubmit(values) : handleSubmit(values)}
              >
                {({ errors, handleSubmit }) => (
                  <StyledFormik>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <FieldWrapper
                          name="email"
                          label={`${strings.emailAddress}`}
                          type="email"
                        />
                      </Grid>
                      {!isForgetPassword ? <Grid item xs={12}>
                        <FieldWrapper
                          name="password"
                          label={`${strings.password}`}
                        />
                      </Grid> : null
                      }
                    </Grid>
                    {console.log('eror', Object.keys(errors).length)}
                    <ForgetPasswordWrapper check={!isForgetPassword}>
                      <ForgetPasswordText onClick={() => setForgetPassword(true)}>{strings.forgottenPassword}</ForgetPasswordText>
                    </ForgetPasswordWrapper>
                    <Box m={1} pt={1}>
                      <StyledButton
                        name="submit"
                        disabled={Object.keys(errors).length > 0 || buttonLoading}
                        onClick={handleSubmit}
                        variant="contained">
                        {error === null && buttonLoading ? (
                          <CircularProgress
                            style={{ color: "white" }}
                            size={20}
                            thickness={5}
                          />
                        ) : renderSubmitButton()}
                      </StyledButton>
                    </Box>
                  </StyledFormik>
                )}
              </Formik>
            )}
            <Divider classes={{ root: classes.strikeStyle }}>{strings.or}</Divider>
          </div>
        }
        <StyledMargin>
          {!isForgetPassword && !isOtpStep ? (
            <StyledText className={classes.textStyle}>{strings.dontHaveAnAccount}{' '}
              <span className="sign-color" onClick={handleSignupButton}>{strings.signUp}</span></StyledText>
          ) : !isOtpStep ? (
            <StyledText className={classes.textStyle}>{strings.haveAnAccount}{' '}
              <span className="sign-color" onClick={handleBackButton}>{strings.signInNow}</span></StyledText>
          ) : (
            <StyledText className={classes.textStyle}>
              <span className="sign-color" onClick={handleBackButton}>← Back to Login</span>
            </StyledText>
          )}
        </StyledMargin>
      </StyledPadding>
    </StyledMainModalCont>
  )
}

export default LoginModal1;